import { useEffect } from 'react';
import { GlobalActions } from '../../model/global-actions';
import appRoutes from '../../routing/app-routes';
import { getConfig, LoginState } from '../../store';
import { useAppDispatch, useAppSelector } from '../redux';
import { useAppNavigation } from '../../utils/navigation.utils';

export const useConfigLogic = (actions: GlobalActions): void => {
  const dispatch = useAppDispatch();
  const { pathname } = useAppNavigation();
  const { navigate } = actions;

  const { config }: LoginState = useAppSelector(
    (state) => state.features.login
  );

  useEffect(() => {
    if (config === undefined) {
      dispatch(getConfig());
    }
  }, [config, dispatch]);

  useEffect(() => {
    if (config?.maintenance === true) {
      navigate(appRoutes.Maintenance, { replace: true });
    } else if (
      config?.maintenance === false &&
      pathname === '/' + appRoutes.Maintenance
    ) {
      navigate(appRoutes.Login, { replace: true });
    }
  }, [config?.maintenance, navigate, pathname]);
};

/**
 * Reads the config again whenever the app comes back to the foreground: the config is otherwise read once per
 * session, so an app left open would never notice that the maintenance started or ended.
 * The platform provides how to listen to the foreground (AppState on mobile, page visibility on web) and returns
 * the function that removes the listener.
 */
export const useConfigRefreshOnForeground = (
  subscribeToForeground: (onForeground: () => void) => () => void
): void => {
  const dispatch = useAppDispatch();

  useEffect(
    () => subscribeToForeground(() => dispatch(getConfig())),
    [subscribeToForeground, dispatch]
  );
};
